<style>
    @import '@/assets/css/custom.css';

    /* Stock Notice Alert Animation */
    .stock-notice-alert {
        animation: slideInBounce 0.6s ease-out;
        border-left: 5px solid;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        position: relative;
        overflow: hidden;
        color: #8b0000 !important;
        font-weight: 600;
    }

    .stock-notice-alert::before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
        animation: shimmer 2s infinite;
    }

    .stock-notice-alert strong {
        color: #6b0000 !important;
        font-weight: 700;
    }

    .stock-notice-alert.alert-warning {
        border-left-color: #ff9800;
        background-color: #fff8e1;
        color: #8b0000 !important;
    }

    .stock-notice-alert.alert-warning strong {
        color: #6b0000 !important;
        font-weight: 700;
    }

    .stock-notice-alert.alert-info {
        border-left-color: #17a2b8;
        background-color: #e7f3f5;
        color: #8b0000 !important;
    }

    .stock-notice-alert.alert-info strong {
        color: #6b0000 !important;
        font-weight: 700;
    }

    @keyframes slideInBounce {
        0% {
            transform: translateX(-100%);
            opacity: 0;
        }
        60% {
            transform: translateX(10px);
            opacity: 1;
        }
        80% {
            transform: translateX(-5px);
        }
        100% {
            transform: translateX(0);
            opacity: 1;
        }
    }

    @keyframes shimmer {
        0% {
            left: -100%;
        }
        100% {
            left: 100%;
        }
    }

    /* Icon animation */
    .stock-notice-alert i {
        display: inline-block;
        animation: bounceIcon 1.5s ease-in-out infinite;
    }

    @keyframes bounceIcon {
        0%, 100% {
            transform: translateY(0);
        }
        50% {
            transform: translateY(-5px);
        }
    }
</style>

<template>
    <div>
        <Breadcrumbs main="Service Management" title="Buy Back Devices" />

        <div class="container-fluid">
            <div class="row">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-body">

                            <div class="col-md-12 project-list page-subtitle">
                                <div class="row">
                                    <div class="col-md-12">
                                        <button class="btn btn-primary float-end" @click="openAddModal">Add Buy Back Device</button>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-12 project-list filter-sort">
                                <div class="row">
                                    <div class="col-md-8 d-flex mt-2">
                                        <label class="d-flex listing-length ms-1"><span>Show</span>
                                            <select class="form-select" v-model="listing_length" @change="fetchBuybackDevices()">
                                                <option value="5">5</option>
                                                <option value="10">10</option>
                                                <option value="20">20</option>
                                            </select>
                                            <span>entries</span>
                                        </label>
                                    </div>
                                    <div class="col-md-2 mt-2">
                                        <select class="form-select" v-model="status" @change="fetchBuybackDevices()">
                                            <option value="">All</option>
                                            <option value="1">Pending</option>
                                            <option value="2">Completed</option>
                                        </select>
                                    </div>
                                    <div class="col-md-2 mt-2">
                                        <input type="text" class="form-control ms-1 float-end" placeholder="Search" v-model="keyword" @input="fetchBuybackDevices()" />
                                    </div>
                                </div>
                            </div>

                            <div class="table-responsive product-table">
                                <table class="display" id="basic-1">
                                    <thead>
                                        <tr align="center">
                                            <th>Sl.No</th>  
                                            <th>Old Device IMEI</th>
                                            <th>New Device IMEI</th>
                                            <th>Customer Name</th>
                                            <th>Dealer Name</th>
                                            <th>Added By</th>
                                            <th>Allocated By</th>
                                            <th>Status</th>
                                            <th>Action</th> 
                                        </tr>
                                    </thead>
                                    <tbody v-if="Boolean(buybackDevices.length)">
                                        <tr v-for="(device, index) in buybackDevices" :key="device.id" align="center">
                                            <td>{{ getSerialNumber(index) }}</td>
                                            <td>{{ device.old_device_imei || 'N/A' }}</td>
                                            <td>{{ device.new_device_imei || 'N/A' }}</td>
                                            <td>{{ device.customer_name || 'N/A' }}</td>
                                            <td>
                                                <span v-if="device.old_dealer_id">Old Dealer: {{ device.old_dealer_name || 'N/A' }}</span><br>
                                                <span v-if="device.new_dealer_id">New Dealer: {{ device.new_dealer_name || 'N/A' }}</span>
                                            </td>
                                            <td>{{ device.added_user_name || 'N/A' }} <br> {{ device.added_date || 'N/A' }}</td>
                                            <td>{{ device.allocated_user_name || 'N/A' }} <br> {{ device.allocated_date || 'N/A' }}</td>
                                            <td>
                                                <span v-if="device.status == 1">
                                                    <span class="badge rounded-pill bg-info">Pending</span>
                                                </span>
                                                <span v-else-if="device.status == 2">
                                                    <span class="badge rounded-pill bg-success">Completed</span>
                                                </span>
                                            </td>
                                            <td>
                                                <button v-if="device.status != 2" class="btn btn-primary btn-sm" @click="openUpdateModal(device)">Update</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody v-else>
                                        <tr>
                                            <td colspan="9" align="center">No data available in the table</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <!----pagination starts --->
                            <caption v-if="Boolean(buybackDevices.length)" class="float-start mt-2 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>
                            <nav aria-label="Page navigation" class="mt-2 float-end">
                                <ul class="pagination">
                                    <li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
                                        <a class="page-link" href="#" @click.prevent="fetchBuybackDevices(page.url + '&limit=' + listing_length + '&status=' + status + '&keyword=' + keyword)" tabindex="-1">
                                            <span v-if="index == 0">Prev</span>
                                            <span v-else-if="index == pagination.length - 1">Next</span>
                                            <span v-else>{{ page.label }}</span>
                                        </a>
                                    </li>
                                </ul>
                            </nav> 
                            <!----pagination ends --->
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
    export default {
        name: "Buy Back Devices",
        
        data() {
            return {
                keyword: "",
                listing_length: 10,
                token: "",
                status: "",
                buybackDevices: [],
                pagination: {},
                current_page: 1,
                from: 0,
                to: 0,
                total: 0,
                active_page_url: "",
            };
        },
        created() {
            this.fetchBuybackDevices();
        },
        methods: {

            getToken() {
                if (localStorage.getItem('airotrack_staff')) {
                    var airotrack_staff =  JSON.parse(localStorage.getItem('airotrack_staff')); 
                            
                    if(airotrack_staff.token) {

                        this.token = airotrack_staff.token;
                        this.user = airotrack_staff;

                    } else {
                        this.$swal("", "Failed to fetch token, please login again", "error");
                        this.$router.push({ name: "login" });
                    }

                } else {
                    this.$swal("", "Session expired, please login again", "error");
                    this.$router.push({ name: "login" });
                }
            },

            fetchBuybackDevices(page_url = null) {
                this.getToken();
                let url = "/staffs/getBuybackDevice?limit=" + this.listing_length + "&keyword=" + this.keyword + "&status=" + this.status;
                page_url = page_url || url;
                this.active_page_url = page_url;
                this.$axios
                    .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
                    .then((res) => {
                        var responseData = res.data.data;
                        console.log(responseData);
                        this.buybackDevices = responseData.replacement_devices.data;
                        this.pagination = responseData.replacement_devices.links;
                        this.current_page = responseData.replacement_devices.current_page || 1;
                        this.from = responseData.replacement_devices.from;
                        this.to = responseData.replacement_devices.to;
                        this.total = responseData.replacement_devices.total;
                        
                    })
                    .catch((err) => console.log(err));
            },

            getSerialNumber(index) {
                return (this.current_page - 1) * this.listing_length + index + 1;
            },

            openAddModal() {
                this.$router.push({ name: 'add_buy_back_device' });
            },

            openUpdateModal(device) {
                this.$router.push({ 
                    name: 'edit_buy_back_device', 
                    params: { id: device.id },
                    query: {
                        old_device_imei: device.old_device_imei || '',
                        new_device_imei: device.new_device_imei || '',
                        customer_name: device.customer_name || '',
                        dealer_id: device.dealer_id || '',
                        dealer_name: device.dealer_name || '',
                        allocated_date: device.allocated_date || '',
                    }
                });
            },
            
        },
    };
</script>